<template>
  <span v-if="badge" class="regulatory-badge" :class="'regulatory-badge-' + badge.tone" :title="badge.title">
    <i class="bi" :class="badge.icon"></i>
    <span class="regulatory-badge-label">{{ badge.label }}</span>
    <span v-if="badge.manual" class="regulatory-badge-manual" title="Tipo escolhido manualmente pelo prescritor">manual</span>
  </span>
</template>

<script>
import {regulatoryBadge} from "@/helpers/regulatoryTypes";

export default {
  name: "RegulatoryBadge",
  props: {
    classification: Object,
  },
  computed: {
    badge() {
      return regulatoryBadge(this.classification);
    },
  },
}
</script>

<style scoped>
.regulatory-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.regulatory-badge i {
  font-size: 0.85rem;
}

.regulatory-badge-manual {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.75;
  border-left: 1px solid currentColor;
  padding-left: 6px;
}

.regulatory-badge-simples {
  background: #f1f3f5;
  border-color: #ced4da;
  color: #495057;
}

.regulatory-badge-retencao {
  background: #fff4e0;
  border-color: #e0a800;
  color: #7a4f00;
}

.regulatory-badge-especial {
  background: #ffe8d6;
  border-color: #d9480f;
  color: #8a2c02;
}

.regulatory-badge-notificacao {
  background: #ffe3e3;
  border-color: #c92a2a;
  color: #8b1a1a;
}

.regulatory-badge-pendente {
  background: #ffffff;
  border: 1px dashed #1864ab;
  color: #1864ab;
}

.regulatory-badge-vedado {
  background: #c92a2a;
  border-color: #8b1a1a;
  color: #ffffff;
}
</style>
